import React, { useState } from "react";
import { Card, Button, Table, Select, DatePicker, Row, Col, Typography } from "antd";
import{ Empty,ConfigProvider} from "antd";
import EmptyData from "../Assets/EmptyData.jpg";


const { Title, Text } = Typography;

const JW_GenPO = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fgColumns = [
    { title: "FG Name", dataIndex: "fgname", key: "fgname" },
    { title: "As Per ReQ", dataIndex: "asperreq", key: "asperreq" },
    { title: "Stock in MSPC", dataIndex: "stockinmspc", key: "stockinmspc" },
    {
      title: "To be Produced",
      dataIndex: "tobeproduced",
      key: "tobeproduced",
      render: (text) => (
        <Button
          type="default"
          size="small"
          style={{
            borderRadius: "5px",
            padding: "0 12px",
            height: "28px",
            fontWeight: 500,
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "duedate",
      key: "duedate",
      render: () => <DatePicker size="small" />,
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const fgData = [
    { key: "01", fgname: "Pusthi", asperreq: "52 T", stockinmspc: "2 Ton", tobeproduced: "52 Ton" },
    { key: "02", fgname: "MLC", asperreq: "10 T", stockinmspc: "2 Ton", tobeproduced: "52 Ton" },
    { key: "03", fgname: "MLM", asperreq: "06 T", stockinmspc: "2 Ton", tobeproduced: "52 Ton" },
    { key: "04", fgname: "UPC", asperreq: "02 T", stockinmspc: "2 Ton", tobeproduced: "52 Ton" },
  ];

  const fgSummary = (pageData) => {
    let reqTotal = 0,
      stockTotal = 0,
      prodTotal = 0;

    pageData.forEach(({ asperreq, stockinmspc, tobeproduced }) => {
      reqTotal += Number(asperreq.replace(/\D/g, ""));
      stockTotal += Number(stockinmspc.replace(/\D/g, ""));
      prodTotal += Number(tobeproduced.replace(/\D/g, ""));
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} />
        <Table.Summary.Cell index={1} align="left">
          <b>Total</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} align="right">
          <b>{reqTotal} Ton</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} align="right">
          <b>{stockTotal} Ton</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} align="right">
          <b>{prodTotal} Ton</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}></Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  const rmColumns = [
    { title: "Raw material Name", dataIndex: "rmName", key: "rmName" },
    { title: "FG1 (Pusthi)", dataIndex: "fg1", key: "fg1" },
    { title: "FG2", dataIndex: "fg2", key: "fg2" },
    { title: "FG3", dataIndex: "fg3", key: "fg3" },
    { title: "FG4", dataIndex: "fg4", key: "fg4" },
    { title: "FG5", dataIndex: "fg5", key: "fg5" },
    { title: "FG6", dataIndex: "fg6", key: "fg6" },
    { title: "FG8", dataIndex: "fg8", key: "fg8" },
    { title: "Overall Total", dataIndex: "total", key: "total" },
  ];

  const rmData = [
    { key: "1", rmName: "Oil", fg1: "0.01 T", fg2: "--", fg3: "0.01 T", fg4: "0.01 T", fg5: "0.01 T", fg6: "0.01 T", fg8: "0.01 T", total: "0.9 T" },
    { key: "2", rmName: "Rice", fg1: "0.01 T", fg2: "0.01 T", fg3: "0.01 T", fg4: "0.01 T", fg5: "0.01 T", fg6: "0.01 T", fg8: "0.01 T", total: "0.9 T" },
    { key: "3", rmName: "Sugar", fg1: "0.01 T", fg2: "0.01 T", fg3: "0.01 T", fg4: "0.01 T", fg5: "0.01 T", fg6: "0.01 T", fg8: "0.01 T", total: "0.9 T" },
    { key: "4", rmName: "Vitamins", fg1: "0.01 T", fg2: "0.01 T", fg3: "0.01 T", fg4: "0.01 T", fg5: "0.01 T", fg6: "0.01 T", fg8: "0.01 T", total: "0.9 T" },
    { key: "5", rmName: "Wheat", fg1: "0.01 T", fg2: "0.01 T", fg3: "0.01 T", fg4: "0.01 T", fg5: "0.01 T", fg6: "0.01 T", fg8: "0.01 T", total: "0.9 T" },
  ];

  
  const cardItems = [
    { title: "FG Selected", value: "2" },
    { title: "To Produce (Nos)", value: "14,900"  },
    { title: "RM Required (Kg)", value: "3,391" },
  ];

  return (
    <div style={{ padding: 20, background: "#f8fafc", minHeight: "100vh" }}>
      
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <div style={{ display: "flex", gap: 8 }}>
          <Button type="default" size="small" style={{ background: "#F2F5F8" }}>
            MSPC:<span style={{ color: "#0166B1" }}>Karwar</span>
          </Button>
          <Button type="default" size="small" style={{ background: "#F2F5F8" }}>
            Month:<span style={{ color: "#0166B1" }}>Aug 2025</span>
          </Button>
        </div>
        <div>
          <Select placeholder="Choose Millet" style={{ width: 160 }}>
            <Select.Option value="millet1">Millet 1</Select.Option>
            <Select.Option value="millet2">Millet 2</Select.Option>
          </Select>
        </div>
      </div>

      
      <Row gutter={16} style={{ marginBottom: 20 }}>
        {cardItems.map((item, index) => (
          <Col span={6} key={index}>
            <Card bordered style={{ textAlign: "center", borderRadius: 12, position: "relative" }}>
             
               <Text style={{ fontWeight: 600 }}>{item.title}</Text>
              <Title level={3} style={{ marginTop: 30, color: "#0166B1" }}>
                {item.value}
              </Title>
              
            </Card>
          </Col>
        ))}
      </Row>
<ConfigProvider
        renderEmpty={() => (
          <Empty
            image={EmptyData}
            description="No Data Available"
            imageStyle={{ height: 200 }}
          />
        )}
      ></ConfigProvider>
      
      <Table
        rowSelection={rowSelection}
        columns={fgColumns}
        dataSource={fgData}
        pagination={false}
        bordered
        size="small"
        summary={fgSummary}
        style={{ marginBottom: 32 }}
      />

      
      <h3 style={{ marginBottom: 12 }}>Raw Materials for Selected FG</h3>
      <Table columns={rmColumns} dataSource={rmData} pagination={false} bordered size="small" style={{ marginBottom: 20 }} />

      
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
        <Button style={{ color: "#0166B1" }}>Save Draft</Button>
        <Button type="primary" style={{ backgroundColor: "#0166B1" }}>
          Gen PO
        </Button>
      </div>
    </div>
  );
};

export default JW_GenPO;
